import SmsConfiguration from 'src/models/Channels/SmsConfiguration';
import VoiceConfiguration from 'src/models/Channels/VoiceConfiguration';
import { isLoadingStatus, useResourceValues } from 'src/presentation/hooks/useResource';
import smsConfigurationResource from 'src/actions/channels/smsConfigurationResource';
import voiceConfigurationResource from 'src/actions/channels/voiceConfigurationResource';
import { Resource } from 'src/actions/shared/createResource';
import { PhoneNumberCapability } from 'src/actions/availableNumbers/availableNumbersResource';

export default function useConfigurationResource(entityType: PhoneNumberCapability) {
  const resources = {
    [PhoneNumberCapability.SMS]: smsConfigurationResource,
    [PhoneNumberCapability.VOICE]: voiceConfigurationResource,
  };
  const resource = resources[entityType] as Resource<SmsConfiguration | VoiceConfiguration>;

  const { loadingState, values } = useResourceValues(resource);

  return { isLoading: isLoadingStatus(loadingState), values };
}
